import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const canRefresh = (url = "") => url.startsWith("/admin") || url === "/auth/me";

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && canRefresh(cfg.url)) {
      cfg._retry = true;
      await api.post("/auth/refresh");
      return api(cfg);
    }
    return Promise.reject(error);
  },
);
